<div
   class="detailsHistoryTrends"
   id="priceChangeHistory">
   <div
      class="modal-header align-items-center justify-content-between p-0"
      style="margin-bottom: 45px; flex-flow: column; align-items: start !important">
      <h5 class="modal-title price-history-title">{{ title() }}</h5>

      <!-- All Practices Table -->
      <div
         class="section smallColoredTable-container"
         style="overflow-y: auto">
         <div class="table-container smallColoredTable">
            <table matSort>
               <thead class="v-greentealbg">
                  <tr class="allPHeader">
                     <th
                        mat-sort-header="requestedOn"
                        class="v-whitecolor">
                        Requested Date
                     </th>
                     <th
                        mat-sort-header="processedOn"
                        class="v-whitecolor">
                        PIMS Date
                     </th>
                     <th
                        mat-sort-header="previousPrice"
                        class="v-whitecolor">
                        Prior Price
                     </th>
                     <th
                        mat-sort-header="reviewPrice"
                        class="v-whitecolor">
                        Requested Price
                     </th>
                     <th
                        mat-sort-header="reviewComment"
                        class="v-whitecolor">
                        Request Details
                     </th>
                     <th
                        mat-sort-header="captainApproved"
                        class="v-whitecolor">
                        Price Change Type
                     </th>
                     <th
                        mat-sort-header="finalPrice"
                        class="v-whitecolor">
                        Resulting Price
                     </th>
                     <th
                        mat-sort-header="finalComment"
                        class="v-whitecolor">
                        Final Comment
                     </th>
                     <th
                        mat-sort-header="recordType"
                        class="v-whitecolor">
                        Type
                     </th>
                  </tr>
               </thead>
               <tbody class="new-vetcor-table-styles">
                  <tr
                     *ngFor="let change of priceChangeData()"
                     style="border-bottom: 1px solid #147d7e24">
                     <td>{{ change.requestedOn | date : "M/d/yyyy" }}</td>
                     <td>{{ change.processedOn | date : "M/d/yyyy" }}</td>
                     <td>{{ change.priorPrice | currency : "USD" : "symbol" : "1.2-2" }}</td>
                     <td>{{ !!change.newCodeRequestId ? undefined : (change.requestedPrice | currency : "USD" : "symbol" : "1.2-2") }}</td>
                     <td class="comments">{{ change.reviewComment }}</td>
                     <td>
                        <span class="badge activity-badge v-darkgray">
                           {{ getChangeTypeText(change.changeType) }}
                        </span>
                     </td>
                     <td>{{ change.finalPrice | currency : "USD" : "symbol" : "1.2-2" }}</td>
                     <td class="comments">{{ change.finalComment }}</td>
                     <td
                        class="v-orangecolor"
                        style="font-weight: 600; font-style: italic; white-space: nowrap">
                        {{
                           change.recordType == "PB"
                              ? "Quantity Break"
                              : change.recordType == "P"
                              ? "Product Price"
                              : change.recordType == "MP"
                              ? "Min Price"
                              : change.recordType == "SF"
                              ? "System Fee"
                              : change.recordType == "PF"
                              ? "Product Fee"
                              : change.recordType == "PG"
                              ? "Product Bundle"
                              : "Product Price"
                        }}
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>
</div>
